/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BenefitsChartMobile_viewer$ref: FragmentReference;
export type BenefitsChartMobile_viewer = {|
  +tradeProgramsQuery: ?$ReadOnlyArray<?{|
    +code: ?string,
    +displayName: ?string,
    +iconUri: ?string,
    +maxPoints: ?number,
    +minPoints: ?number,
  |}>,
  +$refType: BenefitsChartMobile_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "BenefitsChartMobile_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tradeProgramsQuery",
      "storageKey": "tradeProgramsQuery(programCodes:[\"MEMBER\",\"BRONZE\",\"SILVER\",\"GOLD\",\"PLATINUM\"])",
      "args": [
        {
          "kind": "Literal",
          "name": "programCodes",
          "value": [
            "MEMBER",
            "BRONZE",
            "SILVER",
            "GOLD",
            "PLATINUM"
          ],
          "type": "[String]"
        }
      ],
      "concreteType": "LoyaltyProgram",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "iconUri",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "maxPoints",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "minPoints",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5f01f8b12059f67ad7a103e4321b8245';
module.exports = node;
